/* eslint 'no-useless-concat' :'off',eqeqeq : 'off'  */

import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';



export function SaveNetworkName(data, callBackFunction){
    return function (dispatch) {
        return APIutil.postData(url.post_SecureConnect, data).then(response => {
            dispatch(global_error_handling(response));
            if(response && response.status === 200){
                callBackFunction && callBackFunction("success");
            } else {
                const message = response && response.statusText ? response.statusText : "Something went wrong. Please try refreshing the page.";
                callBackFunction && callBackFunction("error", { message });
            }
        }).catch(error => {
            callBackFunction && callBackFunction("error", error);
            throw error;
        })
    }
}

export function GetExternalHubURILink(callBackFunction){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_ConfigValue).then(response => {
            dispatch(global_error_handling(response));
            if(response && typeof response === "string"){
                dispatch(actionToStoreSuccess(response,types.GET_EXTERNALURI_TEMPLATE_DETAILS));
                callBackFunction && callBackFunction("success");
            } else {
                const message = response && response.statusText ? response.statusText : "Something went wrong. Please try refreshing the page.";
                callBackFunction && callBackFunction("error", { message });
            }
        }).catch(error => {
            callBackFunction && callBackFunction("error", error);
            throw error;
        })
    }
}

export function GetNetworkListData(callBackFunction){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_NetworkList).then(response => {
            dispatch(global_error_handling(response));
            if(Array.isArray(response)){
                dispatch(actionToStoreSuccess(response, types.GET_NETWORKLIST_TEMPLATE_DETAILS));
                callBackFunction && callBackFunction("success");
            } else {
                const message = response && response.statusText ? response.statusText : "Something went wrong. Please try refreshing the page.";
                callBackFunction && callBackFunction("error", { message });
            }
        }).catch(error => {
            callBackFunction && callBackFunction("error", error);
            throw error;
        })
    }
}


export function PostCertificate(certfile, callbackFunction) {
    return (dispatch) => {
        return APIutil.postImage(url.post_CertificateFile,certfile).then(response => {
            dispatch(global_error_handling(response));
            if(response && response.status === 200 && response.data && response.data.errorInformation === 0){
                // dispatch(GetCertificateList());
                callbackFunction && setTimeout(() => { callbackFunction("success")}, [3000]);
            } else {
                callbackFunction && callbackFunction("error", { 
                    message: response.statusText ? response.statusText : "Something went wrong please try again.",
                    errorCode: response && response.data && response.data.errorInformation ? response.data.errorInformation : undefined
                });
            }
        }).catch(error => {
            callbackFunction && callbackFunction("error", error);
            throw error;
        })
    }
}

export function GetCertificateList(callbackFunction){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_CertificateList).then(response => {
            dispatch(global_error_handling(response));
            if(Array.isArray(response)){
                dispatch(actionToStoreSuccess(response, types.GET_CERTIFICATELIST_TEMPLATE_DETAILS));
                callbackFunction && callbackFunction("success");
            } else {
                const message = response.statusText ? response.statusText : "Something went wrong please try refreshing the page.";
                callbackFunction && callbackFunction("error", { message });
            }
        }).catch(error => {
            callbackFunction && callbackFunction("error", error);
            throw error;
        })
    }
}

export function downloadCertificate(certificateId, fileName="DownloadedFile.txt") { 
    return APIutil.getPDFDataAPI(url.get_generated_certificate + "/" +certificateId)
        .then(response => {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([response]), fileName);
            } else {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(error => { 
            throw error;
        })
}

export function GetNetworkDetailList(networkId){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_NetworkDetailList+"/"+networkId).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined){
                dispatch(actionToStoreSuccess(response,types.GET_NETWORKDETAILLIST_TEMPLATE_DETAILS));
            }
        }).catch(error => {throw error;})
    }
}

export function actionToStoreSuccess(response,actionType){
    return{
        type : actionType,
        getResponse : response,
    }
}